import { useProgressTimer } from 'hooks/useProgressTimer';
import type { TimeInterval } from 'state/quotes/dashboard/model';

export function useAutoRefreshTimer(interval: TimeInterval) {
  return useProgressTimer(interval.start, interval.durationInMs);
}
